import React from 'react';
import { useNavigate } from 'react-router-dom';
import { StyledChapterBlock, StyledChapterTimeContainer, StyledChapterTime, StyledChapterIcon, Spacer, StyledChapterTitleContainer, StyledChapterTitle, StyledChapterButton } from './PlayerDashboard.styled';

interface IChapterBlockProps {
  title: string;
  time: string;
  image: string;
  link: string;
  onClick?: (e: any) => any;
}

export const ChapterBlock: React.FC<IChapterBlockProps> = ({ title, time, image, link, onClick }) => {
  const navigate = useNavigate();
  
  const onClickHandler = (e: any) => {
    if (onClick) {
      onClick(e);
      
      return;
    }
    navigate(link);
  }

  return (
    <StyledChapterBlock onClick={onClickHandler}>

      <StyledChapterTimeContainer>
        <StyledChapterTime>{time}</StyledChapterTime>
      </StyledChapterTimeContainer>

      <StyledChapterIcon cmsSrc={image} />
      <Spacer />
      <StyledChapterTitleContainer>
        <StyledChapterTitle dangerouslySetInnerHTML={{ __html: title }} />
      </StyledChapterTitleContainer>
      <StyledChapterButton cmsSrc={'images/button'} />

    </StyledChapterBlock>
  )
}